export const TEMPLATE_WRITE = 'TEMPLATE_WRITE';
export const TEMPLATE_DELETE = 'TEMPLATE_DELETE';
export const ARTIFACTS_WRITE = 'ARTIFACTS_WRITE';
export const ENVIRONMENT_CONFIGURE = 'ENVIRONMENT_CONFIGURE';
export const BLUEPRINT_TEMPLATE_DELETE = 'BLUEPRINT_TEMPLATE_DELETE';
export const BLUEPRINT_TEMPLATE_WRITE = 'BLUEPRINT_TEMPLATE_WRITE';
export const ENVIRONMENT_DESTROY = 'ENVIRONMENT_DESTROY';
export const RELEASE_FULL = 'RELEASE_FULL';
export const RELEASE_SCALE_UP = 'RELEASE_SCALE_UP';
export const RELEASE_SCALE_DOWN = 'RELEASE_SCALE_DOWN';
export const RELEASE_FULL_ALLOW_DESTROY = 'RELEASE_FULL_ALLOW_DESTROY';
export const RELEASE_SELECTIVE = 'RELEASE_SELECTIVE';
export const RELEASE_SELECTIVE_ALLOW_DESTROY =
  'RELEASE_SELECTIVE_ALLOW_DESTROY';
export const RELEASE_CUSTOM = 'RELEASE_CUSTOM';
export const RELEASE_CUSTOM_ALLOW_DESTROY = 'RELEASE_CUSTOM_ALLOW_DESTROY';
export const RELEASE_PLAN = 'RELEASE_PLAN';
export const RELEASE_APPLY_PLAN = 'RELEASE_APPLY_PLAN';

export const ARTIFACT_CI_WRITE = 'ARTIFACT_CI_WRITE';
export const PROMOTIONAL_WORKFLOW_WRITE = 'PROMOTIONAL_WORKFLOW_WRITE';
export const PROMOTIONAL_WORKFLOW_DELETE = 'PROMOTIONAL_WORKFLOW_DELETE';
export const ROLE_CC_ADMIN = 'ROLE_CC-ADMIN';
export const USER_DELETE = 'USER_DELETE';
export const USER_WRITE = 'USER_WRITE';
export const USER_READ = 'USER_READ';
export const CUSTOM_ROLE_WRITE = 'CUSTOM_ROLE_WRITE';
export const CUSTOM_ROLE_DELETE = 'CUSTOM_ROLE_DELETE';
export const CUSTOM_ROLE_READ = 'CUSTOM_ROLE_READ';
export const USER_GROUP_WRITE = 'USER_GROUP_WRITE';
export const USER_GROUP_DELETE = 'USER_GROUP_DELETE';
export const USER_GROUP_READ = 'USER_GROUP_READ';
export const OAUTH_INTEGRATION_WRITE = 'OAUTH_INTEGRATION_WRITE';
export const OAUTH_INTEGRATION_DELETE = 'OAUTH_INTEGRATION_DELETE';
export const CHANNEL_WRITE = 'CHANNEL_WRITE';
export const SUBSCRIPTION_DELETE = 'SUBSCRIPTION_DELETE';
export const SUBSCRIPTION_WRITE = 'SUBSCRIPTION_WRITE';
export const ARTIFACTORY_WRITE = 'ARTIFACTORY_WRITE';
export const ACCOUNTS_WRITE = 'ACCOUNTS_WRITE';
export const ACCOUNTS_DELETE = 'ACCOUNTS_DELETE';
export const ENVIRONMENT_LAUNCH = 'ENVIRONMENT_LAUNCH';
export const RESOURCE_GROUP_WRITE = 'RESOURCE_GROUP_WRITE';
export const RESOURCE_GROUP_DELETE = 'RESOURCE_GROUP_DELETE';
export const RESOURCE_GROUP_READ = 'RESOURCE_GROUP_READ';
export const RESOURCE_OVERRIDE = 'RESOURCE_OVERRIDE';
export const RESOURCE_WRITE = 'RESOURCE_WRITE';
export const RESOURCE_DELETE = 'RESOURCE_DELETE';
export const ARTIFACT_ROUTING_RULE_WRITE = 'ARTIFACT_ROUTING_RULE_WRITE';
export const ARTIFACT_ROUTING_RULE_DELETE = 'ARTIFACT_ROUTING_RULE_DELETE';
export const VIEW_RESOURCE_SECRETS = 'VIEW_RESOURCE_SECRETS';

export const STACK_CONFIGURE = 'STACK_CONFIGURE';
export const STACK_WRITE = 'STACK_WRITE';
export const STACK_DELETE = 'STACK_DELETE';
export const CHANNEL_DELETE = 'CHANNEL_DELETE';
export const ARTIFACTORY_DELETE = 'ARTIFACTORY_DELETE';
export const COST_EXPLORER_VIEW = 'COST_EXPLORER_VIEW';
export const AUDIT_LOGS_VIEW = 'AUDIT_LOGS_VIEW';
export const RELEASE_STREAM_WRITE = 'RELEASE_STREAM_WRITE';
export const RELEASE_STREAM_DELETE = 'RELEASE_STREAM_DELETE';
export const OPA_WRITE = 'OPA_WRITE';
export const OPA_DELETE = 'OPA_DELETE';
export const VPN_CONNECT = 'VPN_CONNECT';
export const VIEW_SECRETS = 'VIEW_SECRETS';
export const RELEASE_PAUSE = 'RELEASE_PAUSE';
export const MAINTENANCE_WINDOW_EDIT = 'MAINTENANCE_WINDOW_EDIT';
export const RELEASE_APPROVAL_AUTHORITY = 'RELEASE_APPROVAL_AUTHORITY';
export const RELEASE_TERRAFORM_EXPORT = 'RELEASE_TERRAFORM_EXPORT';

export const USER_PERMISSIONS = [USER_WRITE, USER_DELETE];
export const CUSTOM_ROLE_PERMISSIONS = [CUSTOM_ROLE_WRITE, CUSTOM_ROLE_DELETE];
export const USER_GROUP_PERMISSIONS = [USER_GROUP_WRITE, USER_GROUP_DELETE];
export const RESOURCE_GROUP_PERMISSION = [
  RESOURCE_GROUP_WRITE,
  RESOURCE_GROUP_DELETE,
];
export const OAUTH_INTEGRATION_PERMISSIONS = [
  OAUTH_INTEGRATION_WRITE,
  OAUTH_INTEGRATION_DELETE,
];
export const ARTIFACTORY_PERMISSIONS = [ARTIFACTORY_WRITE];
export const ACCOUNTS_PERMISSIONS = [ACCOUNTS_WRITE, ACCOUNTS_DELETE];
export const SUBSCRIPTION_PERMISSIONS = [
  SUBSCRIPTION_WRITE,
  SUBSCRIPTION_DELETE,
];
export const CHANNEL_PERMISSIONS = [CHANNEL_WRITE];
export const PROJECT_TYPE_WRITE = 'PROJECT_TYPE_WRITE';
export const PROJECT_TYPE_DELETE = 'PROJECT_TYPE_DELETE';
export const MODULE_WRITE = 'MODULE_WRITE';
export const MODULE_READ = 'MODULE_READ';
export const MODULE_DELETE = 'MODULE_DELETE';
export const WEB_COMPONENT_WRITE = 'WEB_COMPONENT_WRITE';
export const WEB_COMPONENT_DELETE = 'WEB_COMPONENT_DELETE';
